import { useContext } from 'react';
import GlobalContext from "../context/GlobalContext.js";
import { X } from 'lucide-react';

export default function AgreementSwitcher({ modalState, setModalState, titleText, children }) {
    const { theme, themeCSS } = useContext(GlobalContext);

    if (!modalState) return null;

    return (
        <>
            {/* Backdrop */}
            <div
                className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm animate-fadeIn"
                onClick={() => setModalState(false)}
            />

            {/* Modal — bottom sheet on mobile, centered on desktop */}
            <div className="fixed inset-0 z-50 flex items-end lg:items-center lg:justify-center lg:p-4">
                <div className={`w-full animate-slideUp flex flex-col rounded-t-2xl lg:rounded-2xl shadow-2xl lg:max-w-md overflow-hidden ${
                    theme === 'dark' ? 'bg-slate-800' : 'bg-white'
                }`}>
                    {/* Header */}
                    <div className={`flex items-center justify-between px-5 py-4 border-b ${
                        theme === 'dark' ? 'border-slate-700' : 'border-gray-100'
                    }`}>
                        <div className="w-8" />
                        <h2 className={`text-base font-bold ${themeCSS.cardTitle}`}>{titleText}</h2>
                        <button
                            onClick={() => setModalState(false)}
                            className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors ${
                                theme === 'dark' ? 'hover:bg-slate-700' : 'hover:bg-gray-100'
                            }`}
                        >
                            <X size={18} className={theme === 'dark' ? 'text-gray-400' : 'text-gray-500'} />
                        </button>
                    </div>

                    {/* Content */}
                    <div className="overflow-y-auto max-h-[60vh] p-3">
                        <div className="space-y-1">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
